import new_germany from "../images/newProductPage/languages/DE.png";
import new_spanish from "../images/newProductPage/languages/ES.png";
import new_french from "../images/newProductPage/languages/FR.png";
import new_italy from "../images/newProductPage/languages/IT.png";
import new_niderland from "../images/newProductPage/languages/ND.png";
import new_polish from "../images/newProductPage/languages/PL.png";
import new_portugal from "../images/newProductPage/languages/PR.png";
import new_russia from "../images/newProductPage/languages/RU.png";
import new_england from "../images/newProductPage/languages/UK.png";

import screen1 from "../images/newProductPage/croatian/1.png";
import screen2 from "../images/newProductPage/croatian/2.png";
import screen3 from "../images/newProductPage/croatian/3.png";
import screen4 from "../images/newProductPage/croatian/4.png";
import screen5 from "../images/newProductPage/croatian/5.png";
import screen6 from "../images/newProductPage/croatian/6.png";

import dlaczego1 from "../images/newProductPage/why/dlaczego_1.webp";
import dlaczego2 from "../images/newProductPage/why/dlaczego_2.webp";
import dlaczego3 from "../images/newProductPage/why/dlaczego_3.webp";

import zdjecie2 from "../images/newProductPage/mission/latop_square.png";
import zdjecie3 from "../images/newProductPage/mission/people_square.png";
import zdjecie1 from "../images/newProductPage/mission/women_square.png";

export const bulgarian = {
  navbar: {
    data: [
      { title: "Поръчай курс", path: "/course" },
      { title: "Вход", path: "/start" },
      { title: "Лексикос", path: "/" },
      { title: "За нас", path: "/about" },
      { title: "Отзиви", path: "/reviews" },
    ],
  },
  mainPage: {
    product_page: {
      language: "bg",
      hero: {
        languages: [
          "на английски",
          "на испански",
          "на немски",
          "на холандски",
          "на италиански",
          "на руски",
          "на полски",
          "на френски",
          "на португалски",
        ],
        title: "Говорете по-уверено,",
        prefix: "с увереност",
        subtitle:
          "Придобийте езикови умения чрез нашия курс, базиран на примери от реалния живот!",
        buttonText: "Поръчайте сега!",
      },
      learning: {
        title: "Как изглежда курсът?",
        config: [
          {
            category: "Научете езика по най-лесния начин",
            image: screen1,
            descriptions: [
              {
                bold: "Десетки уроци",
                rest: "с примери, базирани на ежедневна комуникация.",
              },
              {
                bold: "Практически фрази",
                rest: "проектирани от носители на езика.",
              },
              {
                bold: "Упражнения,",
                rest: "които ефективно развиват четене, слушане и говорене.",
              },
            ],
          },
          {
            image: screen2,
            category: "Практически уроци",
            description:
              "Всяко ниво на обучение се състои от десетки уроци, адаптирани към вашите нужди.",
          },
          {
            image: screen3,
            category: "Задачи",
            description:
              "Нашите упражнения ефективно подкрепят повторението на материала и подобряват паметта.",
          },
          {
            image: screen4,
            category: "Думи, фрази и изрази",
            description:
              "Всяка лекция съдържа внимателно подбрани изображения, които правят процеса на учене интуитивен.",
          },
        ],
        photoData: [screen1, screen2, screen3, screen4, screen5, screen6],
      },
      languages: {
        languages: [
          { image: new_england, lang: "Английски" },
          { image: new_french, lang: "Френски" },
          { image: new_spanish, lang: "Испански" },
          { image: new_niderland, lang: "Холандски" },
          { image: new_germany, lang: "Немски" },
          { image: new_italy, lang: "Италиански" },
          { image: new_russia, lang: "Руски" },
          { image: new_portugal, lang: "Португалски" },
          { image: new_polish, lang: "Полски" },
        ],
        title: "Налични езици:",
        description:
          "Подгответе се за следващото си пътуване или добавете езикови умения към автобиографията си.",
      },
      expertSection: {
        title: "Вашият езиков експерт",
        firstSectionTitle: "Поддръжка на една ръка разстояние",
        firstSectionDescription:
          "Получавайте пълна поддръжка по време на обучението си!",
        secondSectionTitle: "Задавайте въпроси и получавайте отговори",
        secondSectionDescription:
          "Всякакви въпроси можете да зададете директно на своя експерт.",
        thirdSectionTitle: "Индивидуален подход на всяка стъпка",
        thirdSectionDescription:
          "Използването на съветите на езиковия експерт ускорява обучението ви.",
      },
      courseValue: {
        title: "Получете повече с eLingo",
        subtitle:
          "Не просто езиково обучение – получете пълен достъп до инструменти.",
        buttonText: "Поръчайте сега!",
        config: [
          {
            title: "Обучение, адаптирано към вашия начин на живот",
            sections: [
              {
                text: "Учете, където и когато искате, благодарение на нашата платформа.",
              },
              {
                text: "Кратките уроци се вписват в ежедневния ви график.",
              },
            ],
          },
          {
            title: "Мотивация на всяка стъпка",
            sections: [
              {
                text: "Поддържайте своята мотивация чрез нашата система за проследяване.",
              },
              {
                text: "Всеки ден учене ви доближава до езикова плавност.",
              },
            ],
          },
          {
            title: "Пълна гъвкавост и персонализация",
            sections: [
              {
                text: "Адаптирайте курса към своето ниво и темпо на учене.",
              },
              {
                text: "Фокусирайте се върху това, което ви интересува най-много.",
              },
            ],
          },
        ],
      },
      faq: {
        title: "Най-често задавани въпроси",
        subtitle: "Имаш въпроси? Ние имаме отговори.",
        sections: [
          {
            title: "За eLingo",
            questions: [
              {
                question: "Какво е eLingo?",
                answer:
                  "eLingo е онлайн платформа за изучаване на чужди езици, която ти помага бързо и ефективно да овладееш говоренето и разбирането на практика.",
              },
              {
                question: "Как работят езиковите курсове на eLingo?",
                answer:
                  "След като се запишеш, получаваш достъп до интерактивни онлайн уроци и материали, които можеш да използваш по всяко време. Курсовете са адаптирани към твоето ниво и цели.",
              },
              {
                question:
                  "Наистина ли eLingo помага за развиване на говоренето?",
                answer:
                  "Да. Нашите курсове са фокусирани върху практическата комуникация – чрез интерактивни упражнения бързо ще преодолееш страха от говорене.",
              },
            ],
          },
          {
            title: "Плащане и доставка",
            questions: [
              {
                question: "Как мога да платя за курса на eLingo?",
                answer:
                  "Можеш да платиш онлайн или при получаване на пратката от куриера.",
              },
              {
                question: "Сигурни ли са моите данни и плащанията ми?",
                answer:
                  "Да. Всички данни се защитават съгласно GDPR, а плащанията – както онлайн, така и при получаване – са напълно сигурни и се обработват от надеждни партньори.",
              },
              {
                question: "Сигурно ли е плащането при получаване?",
                answer:
                  "Да. Курирът доставя пратката, а плащането се извършва по безопасен начин при получаването ѝ.",
              },
              {
                question: "Кога ще получа достъп до курса след плащане?",
                answer:
                  "Достъпът се активира автоматично чрез въвеждане на кода на посочената страница.",
              },
              {
                question: "Какво става, ако не получа пратката?",
                answer:
                  "Ако не получиш пратката, достъпът до курса няма да бъде активиран. Можеш обаче да направиш нова поръчка по всяко време, когато ти е удобно.",
              },
            ],
          },
          {
            title: "Сигурност, доверие и поддръжка",
            questions: [
              {
                question: "Сигурни ли са моите лични данни в eLingo?",
                answer:
                  "Да. Използваме криптиране и стандарти за защита на данните, съобразени с европейските регулации.",
              },
              {
                question: "eLingo легална и регистрирана компания ли е?",
                answer:
                  "Да. eLingo е образователна марка, собственост на European Learning Agency, която работи в съответствие със закона и е регистрирана в Европейския съюз. Подробна информация за компанията и регистрацията можеш да намериш в условията на сайта ни.",
              },
              {
                question:
                  "Как мога да се свържа с екипа за поддръжка на eLingo?",
                answer:
                  "Можеш да ни пишеш на support.bg@elingo-edu.com или да използваш контактната форма на нашия уебсайт.",
              },
              {
                question:
                  "Предлагате ли гаранция за удовлетворение или връщане на пари?",
                answer:
                  "Да. Ако курсът не отговаря на очакванията ти, предлагаме възможност за отказ или възстановяване на сумата съгласно условията – без риск.",
              },
            ],
          },
        ],
      },
    },
  },
  aboutUs: {
    hero: {
      title: "Мисия",
      description: `Вярваме, че езикът формира мост между културите, и нашата мисия е да преодолеем комуникационните бариери и да сближим хората чрез езиково образование.`,
    },
    why: {
      title: "Защо ние?",
      config: [
        {
          title: "Иновативни образователни методи",
          image: dlaczego1,
          description:
            "Нашият усъвършенстван и тестван в практиката алгоритъм за обучение адаптира материалите към вашето текущо ниво на знания и го разширява чрез ефективно преподаване.",
        },
        {
          title: "Широк спектър от езици",
          image: dlaczego2,
          description:
            "Предлагаме курсове по най-популярните световни езици. Това ви позволява да изберете езика, който отговаря на вашите нужди.",
        },
        {
          title: "Образование по забавен начин",
          image: dlaczego3,
          description:
            "Нашата платформа прави изучаването на езици забавно и приятно преживяване, така че ще бъдете мотивирани да учите езици.",
        },
      ],
    },
    mission: {
      config: [
        {
          title: "Персонализация и достъпност",
          description:
            "Нашият ефективен алгоритъм за машинно обучение постоянно работи, за да предостави подходящи материали на ниво за всеки индивид. Лексикос позволява на учащите да откриват модели самостоятелно, без да се фокусират върху правилата на езика – точно както сте научили майчиния си език в детството.",
          image: zdjecie1,
        },
        {
          title: "Комбинация от технология и наука",
          description:
            "Лексикос използва смела комбинация от технология и наука, за да стимулира ума към действие. Повтарянето на безброй списъци с думи и изрази е скучно, и вашият мозък го знае. Нашият метод е вълнуващ и ефективен, принуждавайки ви да използвате придобитите знания по различни начини в конкретни моменти - вашият мозък ще оцени това решение!",
          image: zdjecie2,
        },
        {
          title: "Общност и ценности",
          description:
            "Езиците помагат на хората да се ангажират. Изучаването на езици улеснява разбирането. Общността на Лексикос събира хора от цял свят. Ние сме амбициозни и винаги разширяваме границите. Вярваме, че изучаването на езици може да бъде забавно и сме любопитни да изследваме нови култури чрез езика.",
          image: zdjecie3,
        },
      ],
    },
  },
  formSender: {
    formControll: {
      pageLink: "https://nyelvfejlesztesi-kozpont.eu/",
      title: "Интересувате се от курса? ",
      title1: "Искате ли повече информация?",
      subtitle: "Оставете телефонния си номер - ще ви се обадим.",
      subtitle1: "Ако вече имате акаунт, моля, попълнете следните полета:",
      button1: "Име и фамилия",
      button2: "Телефонен номер",
      button3: "Имейл",
      buttonSub: "Изпрати",
      checkOne:
        "С изпращането на този формуляр приемам условията и декларирам, че съм прочел следното",
      checkOneTwo: "следното",
      checkTwo: "Съгласявам се да бъда контактуван за маркетингови цели",
      textOne: "Моля, бъдете информирани, че",
      textTwo:
        "Администратор на вашите лични данни е ELA Sp. z o.o., със седалище във Варшава, ул. Млинарска 42 / 115, 01-171, регистрирана в регистъра на предприемачите, поддържан от районния съд на Варшава под KRS5273057993, REGON: 525396900, NIP5273057993. Вашите лични данни ще бъдат обработвани във връзка със запитването чрез формуляра за контакт или изпълнението на сключения договор. Като се свържете с нас, вие доброволно се съгласявате с обработката на вашите лични данни за горепосочените цели. Имате право на достъп, коригиране, изтриване или ограничаване на обработката на вашите данни, да възразите срещу обработката и да прехвърляте данните. Имате право и да оттеглите съгласието си по всяко време, но оттеглянето на съгласието не засяга законосъобразността на обработката, основана на съгласие преди неговото оттегляне. Имате право и да подадете жалба до надзорния орган. Предоставянето на данни е доброволно, но може да бъде необходимо за отговор на запитване или изпълнение на договор. Личните данни ще се съхраняват за периода, необходим за горепосочените цели, но не по-дълго от периода на давност на исковете съгласно общото право. Моля, прочетете внимателно политиката за поверителност",
      buttonMore: "Прочетете повече",
      buttonLess: "Прочетете по-малко",
      subOne: "условия",
      subTwo: "и правила за поверителност.",
      buttonTXT: "Благодаря",
      rulesLink: "/Regulations_BG_European_Learning_Agency_elingo.pdf",
      privacyLink: "Privacy_BG_European_Learning_Agency.pdf",
      product: "ebe",
      market: "bg",
      send_to_url: "https://crm.eou-edu.eu/api/v1/cms/create_order",
      utm_source: "Platform_eLingo",
      product_variant: "en-bg",
      server_link: "https://cms.eou-edu.eu/integration/lead-from-landing",
      currency: "eur",
      price: 97,
    },
  },
  courseV2: {
    formControll: {
      title: "Поръчайте курса",
      title1: "с доставка до вашия адрес",
      subtitle: "Изберете език и попълнете данните за доставка.",
      languageLabel: "Изберете език",
      productVariants: [
        { value: "bg-en", label: "Английски" },
        { value: "bg-de", label: "Немски" },
        { value: "bg-it", label: "Италиански" },
        { value: "bg-es", label: "Испански" },
        { value: "bg-fr", label: "Френски" },
        { value: "bg-nl", label: "Нидерландски" },
        { value: "bg-ru", label: "Руски" },
        { value: "bg-pl", label: "Полски" },
        { value: "bg-pt", label: "Португалски" },
      ],
      button1: "Име и фамилия",
      button2: "Телефонен номер",
      phoneHint: "Въведете валиден български телефонен номер, напр. 0888 123 456",
      button3: "Имейл",
      deliveryTitle: "Начин на доставка",
      deliverySpeedy: "Куриер Speedy",
      deliverySpeedyInfo: "Доставка до адрес в цяла България",
      addressTitle: "Адрес за доставка",
      city: "Град / село",
      postalCode: "П. код",
      postalCodeHint: "Пощенският код трябва да съдържа 4 цифри",
      street: "Улица / ж.к.",
      streetNumber: "№ / бл.",
      apartment: "Вход, етаж, апартамент",
      priceLabel: "Цена на курса:",
      price: 97,
      currency: "€",
      buttonSub: "Поръчай",
      buttonTXT: "Благодаря",
      buttonText: "Получихме вашата поръчка.",
      checkOne:
        "С изпращането на този формуляр приемам условията и декларирам, че съм прочел следното",
      checkTwo: "Съгласявам се да бъда контактуван за маркетингови цели",
      textOne: "Моля, бъдете информирани, че",
      textTwo:
        "Администратор на вашите лични данни е ELA Sp. z o.o., със седалище във Варшава, ул. Млинарска 42 / 115, 01-171, регистрирана в регистъра на предприемачите, поддържан от районния съд на Варшава под KRS5273057993, REGON: 525396900, NIP5273057993. Вашите лични данни ще бъдат обработвани във връзка със запитването чрез формуляра за контакт или изпълнението на сключения договор. Като се свържете с нас, вие доброволно се съгласявате с обработката на вашите лични данни за горепосочените цели. Имате право на достъп, коригиране, изтриване или ограничаване на обработката на вашите данни, да възразите срещу обработката и да прехвърляте данните. Имате право и да оттеглите съгласието си по всяко време, но оттеглянето на съгласието не засяга законосъобразността на обработката, основана на съгласие преди неговото оттегляне. Имате право и да подадете жалба до надзорния орган. Предоставянето на данни е доброволно, но може да бъде необходимо за отговор на запитване или изпълнение на договор. Личните данни ще се съхраняват за периода, необходим за горепосочените цели, но не по-дълго от периода на давност на исковете съгласно общото право. Моля, прочетете внимателно политиката за поверителност",
      buttonMore: "Прочетете повече",
      buttonLess: "Прочетете по-малко",
      subOne: "условия",
      subTwo: "и правила за поверителност.",
      rulesLink: "/Regulations_BG_European_Learning_Agency_elingo.pdf",
      privacyLink: "Privacy_BG_European_Learning_Agency.pdf",
    },
  },
  reviews: {
    language: "bg",
    title: "Мнения за eLingo",
    subtitle:
      "Твоето мнение има значение - отзивите за eLingo ни помагат да развиваме платформата в съответствие с нуждите на потребителите.",
    contentPlaceholder: "Започни да пишеш",
    submitButton: "Изпрати",
    thankYouText:
      "Благодарим ви, че споделяте опита си и заедно с нас създавате ефективен инструмент за изучаване на езици!",
    recommendedLabel: "Препоръчано",
    items: [
      {
        text: "Методът на преподаване е отличен, далеч пред това, което съм срещал на други платформи.",
        isRecommended: true,
      },
      {
        text: "Благодарение на интерактивните упражнения напреднах бързо. Препоръчвам с увереност на всеки, който иска истински резултати.",
        isRecommended: true,
        isLarge: true,
      },
      {
        text: "Много интуитивна платформа. Свикнах с нея от първите минути без никаква помощ.",
        isRecommended: true,
      },
      {
        text: "Техническата поддръжка е бърза. Нито за секунда не се почувствах сам в този процес.",
        isRecommended: true,
      },
      {
        text: "Материалите са изключително добре структурирани и дават ясна представа за процеса на учене. Всеки урок логично следва предишния, което прави напредъка много естествен и интуитивен. Обясненията са подробни, а практическите примери помагат изключително много за затвърждаване на знанията, превръщайки ученето в приятно и ефективно дългосрочно преживяване.",
        isRecommended: true,
        isTall: true,
      },
      {
        text: "Гъвкавостта е най-голямото предимство. Мога да уча по всяко време, навсякъде, на всяко устройство.",
        isRecommended: true,
      },
      {
        text: "Дизайнът е приятен за очите. Мога да уча с часове, без да се уморявам.",
        isRecommended: true,
      },
      {
        text: "Успях да подобря речниковия си запас за рекордно време. Всичко е много практично.",
        isRecommended: true,
      },
      {
        text: "Наистина модерен опит в ученето. Помогна ми да преодолея страха да говоря на чужд език.",
        isRecommended: true,
        isLarge: true,
      },
      {
        text: "Аудиокачеството на курсовете е безупречно, което е от съществено значение за правилното разбиране.",
        isRecommended: true,
      },
      {
        text: "Системата за геймификация те мотивира да се връщаш всеки ден и да напредваш постоянно.",
        isRecommended: true,
      },
      {
        text: "Удивително е как виждаш видим напредък от седмица на седмица. Инвестицията си струва!",
        isRecommended: true,
      },
      {
        text: "Интерфейсът е чист, без реклами и елементи, които да те разсейват от ученето.",
        isRecommended: true,
      },
      {
        text: "Общността е много активна и приветлива. Винаги намираш отговори на въпросите.",
        isRecommended: true,
      },
    ],
  },
  footer: {
    title: "Присъединете се към нас на:",
    phoneInfo: "Нашата линия за продажба → ",
    callChargeInfo:
      "Обаждането се таксува според тарифния план на вашия оператор",
    phoneNo: "+359 29062457",
    privacy: "Поверителност",
    privacyLink: "Privacy_BG_European_Learning_Agency.pdf",
    rules: "Условия за ползване",
    rulesLink: "/Regulations_BG_European_Learning_Agency_elingo.pdf",
    deliveryInfo: "Доставката се извършва от",
  },
};
